__turbopack_context__.v({
  "caption": "BentoCard-module__Tfa9WW__caption",
  "card": "BentoCard-module__Tfa9WW__card",
  "imageContainer": "BentoCard-module__Tfa9WW__imageContainer",
  "imageContainerCentered": "BentoCard-module__Tfa9WW__imageContainerCentered",
  "textContainer": "BentoCard-module__Tfa9WW__textContainer",
  "title": "BentoCard-module__Tfa9WW__title",
});
